export const activityNamespace = "aws.connect.activity";
